import {createRouter, createWebHistory} from 'vue-router'
import {routes} from './routes.js'

//Scroll behaviour for router
const scrollBehavior = (to, from, savedPosition) => {
  if (to.hash && document.querySelector(to.hash)) {
    return {el: to.hash}
  }
  else if (savedPosition) {
    return savedPosition
  }
  return {top: 0}
}

//Create history and router
export const history = createWebHistory(import.meta.env.BASE_URL)
export const router = createRouter({history, routes, scrollBehavior})

//Detect global routing failures
router.afterEach((to, from, failure) => {
  if (failure) {
    console.error('Global routing failure', failure)
  }
})
